'use strict';

angular.module('adelementAdminApp')
	.controller('UserAdvertiserMappingDeleteController', function($scope, $uibModalInstance, entity, UserAdvertiserMapping) {

        $scope.userAdvertiserMapping = entity;
        $scope.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        $scope.confirmDelete = function (id) {
            UserAdvertiserMapping.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };

    });
